(function () {
  'use strict';
  var script = document.currentScript, site = script && script.dataset.site, api = script && script.dataset.api;
  if (!api || !['plaques','plaques_de'].includes(site) || window.__cpOrderDetailsInstalled) return;
  window.__cpOrderDetailsInstalled = true;
  var originalFetch = window.fetch.bind(window);
  var errorText = site === 'plaques_de' ? 'Die Entwurfsdetails konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.' : 'Your design details could not be saved. Please try again.';
  var rawKeys = ['_Design-Daten','_Design Data','Design Data'];
  function metadata(props) { return rawKeys.map(function (key) { return props[key]; }).find(function (v) { return typeof v === 'string' && v.trim(); }); }
  async function prepare(id, props, signal) {
    var meta = metadata(props);
    if (!meta || props['_Production sheet'] || props['_Fertigungsblatt']) return null;
    var response = await originalFetch(api + '/api/design/production', { method: 'POST', signal: signal, headers: { 'Content-Type': 'application/json', 'X-Site-Id': site }, body: JSON.stringify({ variantId: id, properties: props, designData: meta }) });
    var data = await response.json();
    if (!response.ok || !data.properties || !Array.isArray(data.replacedKeys)) throw Error(data.error || errorText);
    return data;
  }
  function replace(props, saved) {
    var result = Object.assign({}, saved.properties);
    Object.keys(props).forEach(function (key) { if (!saved.replacedKeys.includes(key) && !Object.hasOwn(result, key)) result[key] = props[key]; });
    return result;
  }
  window.fetch = async function (input, options) {
    var url;
    try { url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href); }
    catch (_) { return originalFetch(input, options); }
    if (!options || String(options.method || 'GET').toUpperCase() !== 'POST' || url.origin !== location.origin || !/\/cart\/add(?:\.js)?$/.test(url.pathname)) return originalFetch(input, options);
    try {
      var body = options.body;
      if (body instanceof FormData) {
        var props = {};
        body.forEach(function (value, key) { var match = key.match(/^properties\[(.*)\]$/); if (match && typeof value === 'string') props[match[1]] = value; });
        var saved = await prepare(body.get('id'), props, options.signal);
        if (!saved) return originalFetch(input, options);
        var next = new FormData();
        body.forEach(function (value, key) { var match = key.match(/^properties\[(.*)\]$/); if (!match || !saved.replacedKeys.includes(match[1])) next.append(key, value); });
        Object.keys(saved.properties).forEach(function (key) { next.set('properties[' + key + ']', saved.properties[key]); });
        return originalFetch(input, Object.assign({}, options, { body: next }));
      }
      if (typeof body !== 'string') return originalFetch(input, options);
      var data;
      try { data = JSON.parse(body); } catch (_) { return originalFetch(input, options); }
      var items = Array.isArray(data.items) ? data.items : [data], changed = false;
      for (var item of items) {
        if (!item || !item.properties) continue;
        var savedItem = await prepare(item.id, item.properties, options.signal);
        if (savedItem) { item.properties = replace(item.properties, savedItem); changed = true; }
      }
      return originalFetch(input, changed ? Object.assign({}, options, { body: JSON.stringify(data) }) : options);
    } catch (error) {
      var message = error.message || errorText;
      window.alert(message);
      return new Response(JSON.stringify({ status: 422, message: message, description: message }), { status: 422, headers: { 'Content-Type': 'application/json' } });
    }
  };
})();
